<!-- 采摘信息组件 -->
<template>
    <div class="pageContent">
        <CommonRow :title="$t('page.pickInfo.pickImage')">
            <CommonImageCard :src="handleImage(pickingInfo.image)" :height="'200px'" />
            <div class="pickingTopBox">
                <CommonCard :type="'bottomCard'" :title="$t('page.pickInfo.pickUser')"
                    :content="`${pickingInfo.userName || '-'}`" :icon="'icon-yuangongfuzeren'" :iconBgSize="'24px'"
                    :bgColor="'rgba(223, 236, 251, 1)'" :iconSize="'16px'" :iconColor="'rgba(42, 130, 228, 1)'"
                    :contentColor="'rgba(42, 130, 228, 1)'" />
                <CommonCard :type="'bottomCard'" :title="$t('page.pickInfo.pickCrop')"
                    :content="`${info.name || '-'}`" :icon="'icon-zhongzhizuowu'" :iconBgSize="'24px'"
                    :bgColor="'rgba(255, 219, 219, 1)'" :iconSize="'16px'" :iconColor="'rgba(212, 48, 48, 1)'"
                    :contentColor="'rgba(212, 48, 48, 1)'" />
                <CommonCard :type="'bottomCard'" :title="$t('page.pickInfo.pickNumber')"
                    :content="`${pickingInfo.weight || 0}`" :icon="'icon-weight'" :iconBgSize="'24px'"
                    :bgColor="'rgba(255, 238, 221, 1)'" :iconSize="'16px'" :iconColor="'rgba(255, 141, 26, 1)'"
                    :contentColor="'rgba(255, 141, 26, 1)'" />
                <CommonCard :type="'bottomCard'" :title="$t('page.pickInfo.pickDate')"
                    :content="`${pickingInfo.pickTime || '-'}`" :icon="'icon-shijian'" :iconBgSize="'24px'"
                    :bgColor="'rgba(217, 245, 243, 1)'" :iconSize="'16px'" :iconColor="'rgba(0, 186, 173, 1)'"
                    :contentColor="'rgba(0, 186, 173, 1)'" />
                <CommonCard :type="'bottomCard'" :title="$t('page.pickInfo.generateTraceability')"
                    :content="`${pickingInfo.isTraceability == 1 ? $t('common.yes') : $t('common.no')}`"
                    :icon="'icon-suyuan'" :iconBgSize="'24px'" :bgColor="'rgba(217, 227, 240, 1)'" :iconSize="'16px'"
                    :iconColor="'rgba(0, 64, 154, 1)'" :contentColor="'rgba(0, 64, 154, 1)'" />
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.pickInfo.pickRemark')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ pickingInfo.remark || "-" }}</div>
            </div>
        </CommonRow>
    </div>
</template>

<script>
import CommonImageCard from '../common/commonImageCard.vue';
import CommonCard from '../common/commonCard.vue';
import { CODE_SUCCESS } from '../../utils/constant.js';
import { validateImageUrl } from '../../utils/index';
export default {
    components: {
        CommonImageCard,
        CommonCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            pickingInfo: {}, // 采摘信息
        };
    },
    methods: {
        async refresh() {
            if (!this.info.pickId) {
                this.pickingInfo = {};
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    id: this.info.pickId
                }
                const res = await this.$api.fetchFarmPickById(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.pickingInfo = res.data || {};
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.pickingTopBox {
    width: 100%;
    height: auto;
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 21px;
    row-gap: 12px;
}
</style>